var noAnim = true; //アニメーションなし
var kvAnim = {
	bgScale:0,
	ease:'easeInOutCubic',
	copy_step:0,
	init:function(){
		var t=this;
		t.bgScale = 1.5;

		$('.product_kv_bg').stop().velocity('stop').velocity({scale:3,opacity:0},1);
		$('.main_sholder').stop().velocity('stop').velocity({opacity:0},1);
		$('.main_ttl').stop().velocity('stop').velocity({opacity:0},1);
		$('.watch_the_video').stop().velocity('stop').velocity({opacity:0},1);
		$('.release_date').stop().velocity('stop').velocity({opacity:0},1);

	},
	show:function(){
		var t = this;
		$('.bg_cover').stop().velocity('stop').velocity({opacity:0},{duration:1400,delay:500,easing:'linear'});
		
		setTimeout(function(){
			$('.main_sholder').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2000});
			$('.main_ttl').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2500});
			$('.watch_the_video').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:3000});
			$('.release_date').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:3500});
		},250);
	},
	copyStep:function($block,num){
		// var t = this;
		// let spd = 750;
		// let dly = (t.copy_step > 0)? 500 : 1000;
		// t.copy_step = num + 2;

		// let $tag = $block.find('.kv_copy_area');

		// t.copyInit($block);
		// $block.addClass('go');
		// $tag.show();
		// $tag.find('.ttl').stop(false,true).velocity('stop').velocity({scale:1,opacity:1},{duration:spd,delay:dly,easing:t.ease});
		// $tag.find('.desc').stop(false,true).velocity('stop').velocity({translateY:0,opacity:1},{duration:spd,delay:dly,easing:t.ease});

		// $('#kv_indi li a.indi_'+num).addClass('active');
	},
	leave:function(){
		// var t = this;
		// let spd = 500;
		// let $block = $('.kv_scrl_block.go');
		// let $tag = $block.find('.kv_copy_area');
		// $tag.find('.ttl').velocity('stop').velocity({opacity:0,translateY:'-100px',scale:1},{duration:spd,delay:0,easing:t.ease});
		// $tag.find('.desc').velocity('stop').velocity({opacity:0,translateY:'-100px'},{duration:spd,delay:100,easing:t.ease,complete:function(){
		// 	t.copyInit($block);
		// }});

		// $block.removeClass('go');

		// $('#kv_indi li a.active').removeClass('active');
	}
}
